export default __webpack_public_path__ + "static/index_about_golf-daedc49d89eb0ac0610dac82c92c1634.png";